const TextareaInput = (props: any) => {
  return (
    <textarea className="devugo-textarea" {...props}>
      ddll
    </textarea>
  );
};

export default TextareaInput;
